module.exports = __webpack_public_path__ + "static/media/placeholder-big.8eea0cae.svg";